<template>
  <div class="card-dialog">
    <el-dialog
      title="支付"
      :visible="true"
      :show-close="false"
      @close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="60px" :rules="rules">
        <el-form-item label="上传" prop="load">
          <el-upload
            class="avatar-uploader"
            action="/"
            multiple
            :file-list="fileList"
            :http-request="uploadImg"
            :on-remove="handleRemove"
            list-type="picture-card"
            accept=".jpg,.png,.jpeg"
            :limit="9"
          >
            <el-button type="primary" ref="uploadImg">
              上传图片
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.one"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="info" @click="handleClose">取消</el-button>
        <el-button type="primary" @click="onSave">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    name: "Pay",
    data(){
      var validateLoad = (rule, value, callback) => {
        if (this.fileList && this.fileList.length > 0) {
          return callback();
        }else {
          callback(new Error('请先上传图片'));
        }
      };
      return{
        rules: {
          load: [
            { required: true, validator: validateLoad, trigger: 'blur' }
          ],
        },
        form: {
          one: '',
        },
        fileList: []
      }
    },
    props: {
      row: {
        type: Object,
        default: ()=>({})
      }
    },
    mounted() {
    },
    methods: {
      // 上传图片
      uploadImg (file) {
        let _self = this;
        const isJPG = file.file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
        if (!isJPG) {
          _self.$message.error('请上传jpg,jpeg,png格式的图片！');
          return;
        }
        let formdata = new FormData();
        formdata.append('file', file.file);
        formdata.append('modular', 'createOrder');
        formdata.append('fileType', '');
        _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
          if (res.data.code == 200) {
            let o = {
              name: file.file.name,
              url: res.data.data
            }
            _self.fileList = [..._self.fileList,o]
            console.log(_self.fileList)
            _self.$message.success('上传成功');
          } else {
            _self.$message.error('上传失败');
          }
        });
      },
      handleRemove(file, fileList) {
        this.fileList = fileList
      },
      handleClose(){
        this.$options.cancel('cancel')
      },
      // 保存
      async onSave(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
            console.log(this.row)
            console.log(this.fileList)
          }
        });

        /*const params = {
          userId: this.row.userId,
        }
        const res = await this.$http.get('/user/level/binding', {params})
        if(res.data.code === 200){
          this.$options.confirm(true)
        }*/
      },
    }
  }
</script>

<style scoped lang="less">
  .card-dialog {
    ::v-deep .el-dialog {
      width: 570px;
    }

    ::v-deep .el-dialog__header {
      text-align: center;
      padding-bottom: 0;
    }
    .dialog-footer{
      text-align: center;
    }
    .box{
      text-align: center;
      .el-button{
        width: 100px;
        text-align: center;
        margin: 20px auto 0;
      }
    }
  }
</style>
